import { combineReducers } from '@reduxjs/toolkit'
import data from './dataslice'

const reducer = combineReducers({
    data
})

export default reducer